import { globalLoggerToken } from "@/tokens";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

@singleton()
export class ElementsIndex {
    private elements: Map<string, HTMLElement> = new Map();

    public constructor(
        @inject(globalLoggerToken) private readonly logger: LoggerInterface
    ) {}

    public registerElement(elementName: string, element: HTMLElement) {
        this.logger.debug("ElementsIndex.registerElement element registred", {
            elementName,
            element,
        });
        this.elements.set(elementName, element);
    }

    public unregisterElement(elementName: string) {
        this.logger.debug(
            "ElementsIndex.unregisterElement element unregistred",
            {
                elementName,
            }
        );
        this.elements.delete(elementName);
    }
}
